import { Sparkles } from "lucide-react";

export const ScoreBadge = ({ score, showIcon = true, size = "sm" }) => {
  if (score === null || score === undefined) {
    return (
      <span
        className="inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium bg-black/5 text-[#86868B]"
        data-testid="score-badge-empty"
      >
        Nicht bewertet
      </span>
    );
  }

  let cls = "bg-zinc-50 text-zinc-600 border-zinc-200/60";
  if (score >= 70) cls = "bg-emerald-50 text-emerald-600 border-emerald-200/60";
  else if (score >= 40) cls = "bg-amber-50 text-amber-600 border-amber-200/60";
  else cls = "bg-rose-50 text-rose-600 border-rose-200/60";

  const pad = size === "lg" ? "px-3 py-1 text-sm" : "px-2.5 py-0.5 text-xs";

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-semibold ${pad} ${cls}`}
      data-testid="score-badge"
    >
      {showIcon && <Sparkles className="h-3 w-3" strokeWidth={2} />}
      {score}
      <span className="opacity-50 font-normal">/100</span>
    </span>
  );
};

export default ScoreBadge;
